import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { UserProvider } from './contexts/user.context';
import { EnvironmentProvider } from './contexts/environment.context';
import { SelectorProvider } from './contexts/selector.context';
import { NavigationProvider } from './contexts/navigation.context';
import { FunctionProvider } from './contexts/function.context';
import { store, persistor } from "./store/store";
import App from './App';
import './index.css';

var debug = require('debug');
var error = debug('app:error');

// enable debugging and error logging

// by default stderr is used
debug.enable('app:error,app:log');
var log = debug('app:log');
// set this namespace to log via console.log
log.log = console.log.bind(console); 

// set all output to go via console.info
// overrides all per-namespace log settings
debug.log = console.info.bind(console);
process.env.NODE_ENV !== 'production' ? error('Starting Non Production App') : log('Starting Production App');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <UserProvider>
            <SelectorProvider>
              <EnvironmentProvider>
                <NavigationProvider>
                  <FunctionProvider>
                    <App />
                </FunctionProvider>
                </NavigationProvider>
              </EnvironmentProvider>
            </SelectorProvider>
          </UserProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
